module.exports = __webpack_public_path__ + "img/paypal.854bd7d9.svg";